import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import { memo } from "react";

const FullScreenIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      sx={{
        fontSize: "inherit",
        fill: "none",
        ...sx,
      }}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.28572 10.2858H0V16.0001H5.71431V13.7144H2.28572V10.2858ZM0 5.71431H2.28572V2.28572H5.71431V0H0V5.71431ZM13.7142 13.7144H10.2856V16.0001H15.9999V10.2858H13.7142V13.7144ZM10.2856 0V2.28572H13.7142V5.71431H15.9999V0H10.2856Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(FullScreenIcon);
